import React from "react";

const ABOUT_IMG = "/headshot.jpg";

const stats = [
  { num: "High Honors", label: "S.J. Quinney College of Law" },
  { num: "Utah Ct. App.", label: "Clerk to Justice Diana Hagen" },
  { num: "U.S. Attorney", label: "Trial Award Recipient" },
  { num: "UELA", label: "Treasurer" },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 bg-[#f5f2ea]/55 border-y border-[#bfa15f]/20"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-12 gap-8 md:gap-14">
          {/* Image column */}
          <div className="col-span-12 lg:col-span-5 lg:sticky lg:top-32 self-start">
            <div className="relative rounded-2xl border border-[#bfa15f] p-2 md:p-2.5 bg-[#fdfbf7]">
              <img
                src={ABOUT_IMG}
                alt="Portrait of Kinsi Bollinger, Utah litigation attorney"
                data-testid="about-image"
                width="1280"
                height="1707"
                loading="eager"
                fetchpriority="high"
                className="w-full h-[480px] md:h-[640px] object-cover object-center rounded-xl"
                style={{ imageRendering: "auto" }}
              />
            </div>
            <div className="mt-8 flex items-center gap-4">
              <span className="gold-rule-solid" />
              <span className="text-[0.72rem] uppercase tracking-[0.28em] text-[#475569]">
                Salt Lake City — Utah
              </span>
            </div>
          </div>

          {/* Bio column */}
          <div className="col-span-12 lg:col-span-7 lg:pl-10">
            <p className="text-overline mb-6">
              <span className="kb-counter mr-2">N&deg; 03</span> About
            </p>
            <h2 className="font-serif-display font-medium text-[#0f172a] tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.02]">
              Ms.
              <span className="italic text-[#1a362d]"> Bollinger.</span>
            </h2>
            <span className="block mt-6 mb-10 gold-rule-solid" />

            <div className="space-y-6 text-[#334155] text-base md:text-[1.05rem] leading-[1.85]">
              <p>
                Ms. Bollinger&rsquo;s practice focuses on{" "}
                <span className="text-[#0f172a] font-medium">
                  employment law and business disputes
                </span>
                . She also has experience handling personal injury cases and is
                increasingly representing clients in elder law matters.
                Dedicated, passionate, and innovative, Ms. Bollinger brings a
                client-centric focus to her cases and is known for her
                unwavering commitment to achieving favorable outcomes.
              </p>
              <p>
                Ms. Bollinger approaches each case with a fresh perspective and
                creative thinking. Her ability to think outside the box enables
                her to develop tailored strategies that yield successful
                results for her clients. She is actively involved in the legal
                community, serving as the{" "}
                <span className="text-[#0f172a] font-medium">
                  treasurer of the Utah Employment Lawyers Association (UELA)
                </span>
                .
              </p>
              <p>
                Ms. Bollinger graduated{" "}
                <span className="italic">with High Honors</span> from the
                University of Utah&rsquo;s S.J. Quinney College of Law on
                scholarship, after completing her undergraduate studies at{" "}
                <span className="italic">Brigham Young University</span>. Her
                outstanding advocacy skills earned her a prestigious trial
                award from the U.S. Attorney&rsquo;s Office while practicing
                under the Third-Year Practice Rule.
              </p>
              <p>
                Following law school, Ms. Bollinger clerked for the Utah Court
                of Appeals with then-Judge, now-Justice, Diana Hagen, gaining
                invaluable insight into the intricacies of the legal system and
                judicial process. The experience solidified her passion for
                the law and instilled in her a deep commitment to justice.
              </p>
            </div>

            {/* Honors grid */}
            <div className="mt-14 grid grid-cols-2 gap-px bg-[#bfa15f]/30 border border-[#bfa15f]/30">
              {stats.map((s, i) => (
                <div
                  key={i}
                  data-testid={`about-stat-${i}`}
                  className="bg-[#fdfbf7] px-6 py-7"
                >
                  <p className="font-serif-display text-2xl md:text-[1.65rem] text-[#1a362d] leading-tight">
                    {s.num}
                  </p>
                  <p className="mt-2 text-[0.72rem] uppercase tracking-[0.22em] text-[#475569]">
                    {s.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
